import { useSheets } from 'features/dashboard-new';
import { useSchool } from 'features/school';

const useResources = () => {
  const { schoolMelver, schoolUuid, schoolAlias } = useSchool();

  const schoolTestSchool = schoolUuid === 'e16f261c-eea5-4757-b333-c6e8fdcbf57d';
  const schoolB3 = schoolUuid === '2809e7aa-8dd8-4925-ac33-bc841cc4a4f0';
  const schoolRcEducacao = schoolUuid === '27b0f3bc-c645-4463-a4d2-201577ede070';
  const schoolInvestSmart = schoolUuid === 'd8fd25f5-721f-445b-8d15-868b813b0196';
  const schoolAvel = schoolUuid === '85f3f0d5-7c2f-4bea-b528-85cfcf8bcaac';
  const schoolBRA = schoolUuid === 'dd84854e-a181-42ed-889f-93b6f126ba9e';
  const schoolDomInvestimentos = schoolUuid === '3549e19f-b07f-4658-950d-694b99c6749d';
  // const schoolTradeAoVivo = schoolUuid === '85338cb1-8075-4dcf-afe2-6ce534dcde27';
  const schoolBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  const schoolMPC = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';
  const schoolDZ = schoolUuid === '14d970bd-3794-4268-bf67-2c5d2d0f0285'; // G10
  const schoolXp = schoolUuid === '8fac3179-be61-4b65-903d-97aaae69d8f8';
  const schoolDVInvest = schoolUuid === '519a0647-e8b4-48bc-9158-d5488d8036bd';
  const schoolTSE = schoolUuid === '76cebc79-bf6c-4144-bab2-947362f3f8c4';
  const schoolActiveTraders = schoolUuid === '65509a25-be01-4017-bede-4e8e749b378a';
  const schoolTerraInvestimentos = schoolUuid === '7c7d284f-096f-4e69-9067-4c3aa59ed4cd';
  const schoolDiarioJaque = schoolUuid === '85338cb1-8075-4dcf-afe2-6ce534dcde27';
  const schoolXpTestSchool = schoolUuid === 'a767c43f-ff95-4955-ab4a-df8fb5c6768a';
  const schoolIsArgentum = schoolUuid === 'a9f154dd-d1f9-abcb-9f08-0242ac11cba2';
  const schoolIsManchester = schoolUuid === '6947f599-06e4-4c3f-818f-4a29247128c8';
  const schoolIsSquad = schoolUuid === '49b36e92-f341-4791-a5eb-8e16717ee70e';
  const schoolIsTopGain = schoolUuid === 'fecec0cf-c2df-463b-ac6c-2c2108b7e310';
  const schoolIsNasEscolas = schoolUuid === '80c8efb9-134c-476f-93ce-126c6dd32bc3';
  const schoolAcifEducacao = schoolUuid === '80e3bfdb-4771-4d99-af4b-e799c389475c';
  const schoolIdp = schoolUuid === 'a98b6645-09d8-4c33-a77b-9f39ce036d56';
  const schoolIsSirius = schoolUuid === '08c95e3a-0b78-4d5d-a83e-d29209a3de59';
  const schoolIsFloripaEdu = schoolUuid === '8f179641-6a59-49c1-9c91-c9f7cd1e3d98';
  const schoolIsCuritibaEdu = schoolUuid === '0a502498-87dd-456e-bb5e-0c21221eb079';
  const schoolIsDemonstracaonasescolas = schoolUuid === '58314b34-5281-4779-85e5-b66750c85d04';
  const schoolIsGenoveva = schoolUuid === 'ea0523e3-57aa-4e98-acd3-92a78d0c95a0';
  const schoolIsBiguacuedu = schoolUuid === '1e05576d-4c09-46da-8845-2b065be91e16';

  // DASDHBOARD
  const { usingDashboard } = useSheets();

  const usingNewDashboard = usingDashboard !== null ? usingDashboard : true;
  // usingDashboard ||
  // schoolMelver ||
  // schoolXp ||
  // schoolB3 ||
  // schoolTestSchool ||
  // schoolRcEducacao ||
  // schoolInvestSmart ||
  // schoolAvel ||
  // schoolBRA ||
  // schoolDomInvestimentos ||
  // // schoolTradeAoVivo ||
  // schoolDiarioJaque ||
  // schoolXpTestSchool ||
  // schoolIsArgentum ||
  // schoolIsManchester ||
  // schoolIsSquad ||
  // schoolIsTopGain ||
  // schoolTerraInvestimentos ||
  // schoolIsNasEscolas ||
  // schoolAcifEducacao ||
  // schoolIdp ||
  // schoolIsSirius ||
  // schoolIsFloripaEdu;

  //TERMS
  let termsLink = 'https://www.melver.com.br/termos-e-politicas/';
  if (schoolAlias === 'b3') {
    termsLink = 'https://www.b3.com.br/pt_br/termos-de-uso-e-protecao-de-dados/termos-de-uso/';
  } else if (schoolAlias === 'topgain') {
    termsLink = 'https://topgain.com/politica-de-privacidade';
  }

  let usingReports = false;
  if (
    schoolMelver ||
    schoolMelver ||
    schoolBenndorf ||
    schoolDZ ||
    schoolMPC ||
    schoolRcEducacao ||
    schoolDVInvest ||
    schoolXp ||
    schoolActiveTraders ||
    schoolTerraInvestimentos ||
    schoolDomInvestimentos ||
    schoolB3 ||
    schoolInvestSmart ||
    schoolIsArgentum ||
    schoolIsManchester ||
    schoolIsSquad ||
    schoolIsTopGain ||
    schoolIsSirius ||
    schoolXpTestSchool ||
    schoolIsFloripaEdu ||
    schoolIsCuritibaEdu ||
    schoolIsGenoveva ||
    schoolIsBiguacuedu
  ) {
    usingReports = true;
  }

  let usingExams = false;
  if (schoolMelver || schoolTSE || schoolXp) usingExams = true;

  const usingTeachers = false;

  let showCoursesInMenu = true;
  if (schoolXp) showCoursesInMenu = false;

  let usingSearch = true;
  if (schoolB3 || schoolXp || schoolTestSchool) {
    usingSearch = true;
  }

  let usingSurvey = true;

  return {
    usingNewDashboard,

    termsLink,

    usingTeachers,

    usingReports,

    usingExams,

    showCoursesInMenu,

    usingSearch,

    usingSurvey,

    schools: {
      schoolTestSchool,
      schoolB3,
      schoolRcEducacao,
      schoolInvestSmart,
      schoolAvel,
      schoolBRA,
      schoolDomInvestimentos,
      // schoolTradeAoVivo,
      schoolBenndorf,
      schoolMPC,
      schoolDZ,
      schoolXp,
      schoolMelver,
      schoolDVInvest,
      schoolTSE,
      schoolDiarioJaque,
      schoolTerraInvestimentos,
      schoolIsArgentum,
      schoolIsManchester,
      schoolIsSquad,
      schoolIsTopGain,
      schoolIsNasEscolas,
      schoolAcifEducacao,
      schoolIdp,
      schoolIsSirius,
      schoolIsFloripaEdu,
      schoolIsCuritibaEdu,
      schoolIsDemonstracaonasescolas,
      schoolIsGenoveva,
      schoolIsBiguacuedu,
    },
  };
};

export default useResources;
